import { Component, Input  } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'bf-validation-summary',
    templateUrl: './validation-summary.component.html',
    styles: [
        `
        span {
            display: block;
        }

        .summary-content {
            min-height: 16px;
        }
    `
    ]
})
export class ValidationSummaryComponent {
    @Input('control') control: AbstractControl;
    @Input('form') form: FormGroup;
}
